module.exports = __webpack_public_path__ + "static/img/function_2.35a7848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/function_2.png
// module id = t+tN
// module chunks = 1